import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { isZzeKf } from "@/axios/config.js";
import { getUserBasic, getProject } from "./assets/js/jsBridge.js";
// 引入sh-jsbridge
import shJsbridge from "sh-jsbridge";
Vue.config.productionTip = false;
import ElementUI from "element-ui"; //全局引入element
import "element-ui/lib/theme-chalk/index.css"; //全局引入element的样式
import blockClickDirective from "./uitls/blockClick";
Vue.directive("block-click", blockClickDirective);
Vue.use(ElementUI); //全局注入element
Vue.prototype.$eventBus = new Vue();
import Vant from "vant";
import "vant/lib/index.css";
Vue.use(Vant);
const getUrlParam = (paramName) => {
  const url = window.location.href;
  const queryString = url.split("?")[1];
  if (queryString) {
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get(paramName);
  }
  return null;
};
router.beforeEach(async (to, from, next) => {
  if (to.meta?.openType == 0) {
    if (store.state.permissionInfo?.permissionCodes) {
      const containsCreatStory = containsUrl(store.state.permissionInfo?.permissionCodes, to.path);
      if (!containsCreatStory) {
        next("/404page");
      }
    }
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  //url有token则pc端登录后打开，没有token分为移动端&pc端没token
  console.log("url参数：" + location.href);
  if (getUrlParam("token")) {
    localStorage.setItem("token", getUrlParam("token"));
    store.commit("setToken", getUrlParam("token"));
    next();
  } else {
    // 移动端,不校验token//
    if (to.meta.white) {
      store.commit("setspflag", 1); // 设置headers默认不检验userid
      if (to.query.pjcode) {
        // h5打开 || 小程序打开
        localStorage.setItem("pjcode", to.query.pjcode);
        store.commit("setpjcode", to.query.pjcode);
      }
      if (to.query.userId) {
        // url带userid,小程序打开
        localStorage.setItem("userId", getUrlParam("userId"));
        store.commit("setuserId", getUrlParam("userId"));
        store.commit("setspflag", ""); //
      }
      if (to.query.fromApp) {
        // 住这儿app打开
        store.commit("setspflag", ""); // app打开时校验userid
        await ZZERProject();
        await ZZERUser();
      }
      if (to.query.fromZZJ) {
        // 自助机打开
        store.commit("setspflag", ""); // app打开时校验userid
        await Promise.all([getZZJPjMsg(), getZZJUserMsg()]);
      }
      // to.query.month,静态页面
      next();
    } else if (
      // pc未登录或登录过期
      !to.meta.white &&
      !store.state.token &&
      !localStorage.getItem("token")
    ) {
      location.href = process.env.VUE_APP_USER_URL + "/gateway-front/#/login";
    } else {
      store.commit("setToken", localStorage.getItem("token"));
      next();
    }
  }
});
// 递归函数用于查找指定的 URL
function containsUrl(menuList, url) {
  for (const item of menuList) {
    if (item.url === url) {
      return true;
    }
    if (item.children && item.children.length > 0) {
      if (containsUrl(item.children, url)) {
        return true;
      }
    }
  }
  return false;
}
async function ZZERUser() {
  return new Promise((resolve) => {
    getUserBasic((res) => {
      console.log("jsb消息:", res);
      localStorage.setItem("userId", res.userId);
      store.commit("setuserId", res.userId);
      localStorage.setItem("mobile", res.usemobilerId);
      store.commit("setmobile", res.mobile);
      //
      store.commit("setzztoken", res.token);
      resolve();
    });
  });
}

async function ZZERProject() {
  return new Promise((resolve) => {
    getProject((res) => {
      console.log("jsb1:", res);
      localStorage.setItem("pjcode", res.projectCode);
      store.commit("setpjcode", res.projectCode);
      resolve();
    });
  });
}
async function getZZJPjMsg() {
  return new Promise((resolve) => {
    shJsbridge.getDeviceInfo().then((res) => {
      console.log("自助机projectCode:", res?.data?.projectCode);
      localStorage.setItem("pjcode", res?.data?.projectCode);
      store.commit("setpjcode", res?.data?.projectCode);
      resolve();
    });
  });
}
async function getZZJUserMsg() {
  return new Promise((resolve) => {
    shJsbridge.readUserInfo().then((res) => {
      console.log("自助机userPhone:", res?.data?.checkedUser?.userPhone);
      if (res?.data?.checkedUser?.userPhone) {
        localStorage.setItem("mobile", res?.data?.checkedUser?.userPhone);
        store.commit("setmobile", res?.data?.checkedUser?.userPhone);
        // 接口调用，获取userId
        isZzeKf({
          projectCode: store.state.pjcode,
          mobile: res?.data?.checkedUser?.userPhone,
        })
          .then((res) => {
            if (res.code == 200 && res.data) {
              localStorage.setItem("userId", res.data);
              store.commit("setuserId", res.data);
            }else{
              localStorage.setItem("userId", '88888888');
              store.commit("setuserId", '88888888');
            }
            resolve();
          })
          .catch((err) => {
            console.log(err);
            localStorage.setItem("userId", '88888888');
            store.commit("setuserId", '88888888');
            resolve();
          });
      } else {
         localStorage.setItem("userId", '88888888');
         store.commit("setuserId", '88888888');
        resolve();
      }
    });
  });
}
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
